<template lang='pug'>
//- 線上諮詢上傳圖片
div(:class='$style[`cc-popbox-uploader`]')
  .popbox-close
    button.popbox-close-btn(
      aria-label='關閉'
      tabindex='0'
      @click='handleClosePopBox')

  div(:class='$style[`cc-content-title`]')
    span.font-bold(:class='$style[`cc-banner-main-title`]')
      span.no-wrap 選擇
      span.font-doctor-theme 上傳
      span.no-wrap 的
      span.font-normal-theme 圖片

    span.font-bold(:class='$style[`cc-banner-main-subtitle`]')

  div(:class='$style[`cc-uploader-content`]')
    div(:class='[$style[`cc-uploader-area`], $style[fileOnDrag ? `isOnDrag` : ``]]')
      input(
        type='file'
        ref='photoUploader'
        name='thumbSrc'
        :class='$style[`cc-uploader-inputer`]'
        @dragenter='handleDragEnter'
        @dragleave='handleDragLeave'
        @dragdrop='handleDragDrop'
        @change='handleChange')

      div(v-if='filePreviewSrc' :class='$style[`cc-uploader-preview`]')
        img(:src='filePreviewSrc' width='100%' height='100%')
      div(v-else :class='$style[`cc-uploader-interface`]')
        IconUpload(:size='40' :color='`#dcdcdc`')
        span(:class='[$style[`cc-uploader-title`], $style[showErrorMsg ? `isError` : ``]]') {{ fileTips }}
        span(:class='$style[`cc-uploader-tip`]')!= '僅支援JPG/PNG格式'

  div(:class='$style[`cc-content-controller`]')
    button(
      title='關閉'
      tabindex='0'
      aria-label='關閉'
      :class='$style[`cc-controller-default`]'
      @click.once='handleClosePopBox')
      span 關閉

    button.btn-confirm-extra(
      title='傳送'
      tabindex='0'
      aria-label='傳送'
      :class='[$style[`cc-controller-confirm`], $style[!canUpload ? `cc-content-disabled` : ``]]'
      @click.once='startUploadFileProcess')
      IconLoading(v-if='showLoading' :size='18' :color='`#fff`')
      span {{ showLoading ? `` : `傳送`}}

</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import { debounce } from 'debounce';
// import Emitter from 'tiny-emitter';
// const emitter = new Emitter();
// import axios from 'axios';

import IconUpload from '../../icon/Upload';
import IconLoading from '../../icon/Loading';

import {
  postEffectChatUpload,
  postChatMessageLineNotification,
} from '../../../js/restapi';

export default {
  components: {
    IconUpload,
    IconLoading,
  },

  data() {
    return {
      avatarFiles: [],
      fileTips: '拖曳或點擊上傳',
      fileOnDrag: false,
      filePreviewSrc: '',
      canUpload: false,

      showLoading: false,
      showErrorMsg: false,
    };
  },

  methods: {
    ...mapMutations({
      changePopBoxStatus: 'global/POPBOX_STATUS',
    }),

    handleClosePopBox() {
      this.changePopBoxStatus({
        active: false,
        include: '',
      });
    },

    handleUploadFile() {
      this.fileOnDrag = false;
      this.showErrorMsg = false;

      const file = this.avatarFiles[0];
      // const newFileName = file.name.replace(/\.[^/.]+$/, '');

      if (file.type === '' || file.type === 'image/jpeg' || file.type === 'image/png') {
        const vm = this;
        // eslint-disable-next-line no-underscore-dangle
        const _URL = window.URL || window.webkitURL;
        const img = new Image();
        img.src = _URL.createObjectURL(file);

        // eslint-disable-next-line func-names
        img.onload = function () {
          // const imgWidth = this.width;
          // const imgHeight = this.height;

          if (file.size < (8000 * 1024)) {
            vm.fileTips = file.name;
            vm.canUpload = true;
            vm.filePreviewSrc = img.src;
          } else {
            vm.showErrorMsg = true;
            vm.fileTips = '檔案過大，需小於8mb';
          }
        };
      } else {
        this.showErrorMsg = true;
        this.fileTips = '不正確的檔案類型';
      }
    },

    handleChange() {
      this.avatarFiles = this.$refs.photoUploader.files;
      this.handleUploadFile();
    },

    handleDragEnter() {
      this.fileOnDrag = true;
    },

    handleDragLeave() {
      this.fileOnDrag = false;
    },

    handleDragDrop() {
      this.fileOnDrag = false;
    },

    startUploadFileProcess: debounce(function(e) {
      this.showLoading = true;

      const fileType = this.avatarFiles[0].type === 'image/jpeg' ? 'jpg' : 'png';
      const timeStamp = new Date().getTime();

      // const jwtAccess = JSON.parse(this.authJwtToken).a;
      const formData = new FormData();

      formData.append(
        'photo',
        this.avatarFiles[0],
        `img${this.loginDjangoId}_${timeStamp}.${fileType}`,
      );
      const parts = this.consultWebSocket.room.split('-');
      const vendorId = parts[0];

      formData.append('room', this.consultWebSocket.room);
      formData.append('user_type', this.loginProfile.user_type);
      formData.append('team_id', vendorId);

      postEffectChatUpload('', formData, {
        headers: {
          'content-Type': 'multipart/form-data',
          // Authorization: `Bearer ${jwtAccess}`,
        },
      })
        .then((res) => {
          const SEND_MSG = {
            category: 'img',
            user_type: this.loginProfile.user_type,
            message: res.data,
            username: this.loginDjangoId,
            room: this.consultWebSocket.room,
            first_name: this.loginProfile.firstName,
            last_name: this.loginProfile.lastName,
            gender: this.loginProfile.gender,
            thumbSrc: this.loginProfile.thumbSrc,
            team_id: vendorId,
          };

          this.consultWebSocket.ws.send(JSON.stringify(SEND_MSG));

          postChatMessageLineNotification('', {
            team_id: vendorId,
            hashcode: this.loginHashCode,
            content: '已傳送了圖片',
          }).then(() => {}).catch(() => {});

          console.log('上傳圖檔成功!!', res.data);

          this.changePopBoxStatus({
            active: true,
            include: 'sendConfirm',
          });

          setTimeout(() => {
            this.handleClosePopBox();
          }, this.POP_DURATION);

          this.showLoading = false;
        })
        .catch((err) => {
          console.log('上傳圖檔錯誤', err.message);
        });
    }, 100),
  },

  // eslint-disable-next-line vue/order-in-components
  computed: {
    ...mapGetters({
      loginProfile: 'user/exportUserProfile',
      loginDjangoId: 'user/exportUserDjangoId',
      loginHashCode: 'user/exportUserHashCode',
      authJwtToken: 'user/exportUserJwtToken',
      consultWebSocket: 'user/exportConsultWebSocket',
    }),
  },
};

</script>

<style module lang='scss'>
  @import '../../../sass/component/page/popbox/popChatUploader.scss';
</style>
